export default __webpack_public_path__ + "static/about-custom-8ad4cc29cc48cbbc015e43d8d9fc4333.png";